module.exports = __webpack_public_path__ + "static/media/Filter.109b3e7e.svg";